import { atom } from "jotai";

export const MemoSaveAtom = atom<boolean>(false);
